import type { TFunction } from 'i18next';
import type { PsychologicalRadarGroup, PsychologicalResult } from '../../model';
import formatScoreOutOf from '../formatters';
import { individualMotivationHeight } from '.';
import { defaultMaxScore } from '@/components/blocks/AssessmentResults/shared/utils';
import type { AssessmentResultItemDataFragment } from '@/gql/graphql';

const parseIndividualMotivation = (
    t: TFunction,
    items: AssessmentResultItemDataFragment[]
): PsychologicalResult | null => {
    const item = items.find(i => i.result.__typename === 'IndividualMotivationResult');
    if (!item || item.result.__typename !== 'IndividualMotivationResult') {
        return null;
    }
    const moduleInstance = item.moduleInstance;
    const result = item.result;

    if (!moduleInstance?.moduleDefinitionIdentifier || !result?.categoryBreakdowns?.length) {
        return null;
    }

    const radarGroups =
        result.categoryBreakdowns.map(cb => {
            const domainMax = Math.max(defaultMaxScore, ...cb.subcategoryAverages.map(s => s.maximumPossibleScore));
            return {
                key: cb.category,
                scoreCards: cb.subcategoryAverages.map(s => ({
                    label: s.subcategory,
                    value: formatScoreOutOf(t, s.averageScore, s.maximumPossibleScore, 1),
                })),
                charts: [
                    {
                        data: cb.subcategoryAverages.map(s => ({
                            axis: s.subcategory,
                            individual: Number(s.averageScore.toFixed(1)),
                        })),
                        maxDomain: domainMax,
                        height: individualMotivationHeight,
                        variant: 'bare',
                        footer: cb.category,
                    },
                ],
            } as PsychologicalRadarGroup;
        }) || [];

    return {
        moduleDefinitionIdentifier: moduleInstance.moduleDefinitionIdentifier ?? '',
        name: moduleInstance.name ?? '',
        description: moduleInstance.description ?? '',
        radarGroups,
    };
};

export default parseIndividualMotivation;
